import { render, staticRenderFns } from "./AddPortPage.vue?vue&type=template&id=d5832b5e&"
import script from "./AddPortPage.vue?vue&type=script&lang=js&"
export * from "./AddPortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports